export const STRIPE = 'stripe';

export const isStipeProvider = (provider: string): boolean => provider === STRIPE;